/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: home.page.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { useEffect, type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Pages from '@/shared/page';
import SEOMetadata from '@/constants/seo';
import App from '@/constants/app';
import Sections from '@/sections';
import Links from '@/constants/links';
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const HomePage: FunctionComponent = () => {
  const { t } = useTranslation('home-page');
  const location = useLocation();

  const headParams = {
    title: `${t('head.title')} | ${App.Name.toUpperCase()}`,
    description: SEOMetadata.description,
    ogType: 'website',
    structuredData: JSON.stringify({
      '@context': `${SEOMetadata.siteUrl}${Links.Public.HOME}`,
      description: SEOMetadata.description
    })
  };

  // Scroll to section, when navigating from another page
  useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [location]);

  return (
    <Pages.Fade headParams={headParams}>
      <Sections.Intros.Home />
      <div id="about-us" className="w-0 h-0 invisible"></div>
      <Sections.AboutUs.WhoAndWhy />
      <Sections.AboutUs.OurMission />
      <Sections.AboutUs.OurVision />
      <div id="services" className="w-0 h-0 invisible"></div>
      <Sections.Services />
      <Sections.AffiliationsAndSoftwares />
      <Sections.Testimonials />
      <Sections.Footer.BottomNavigation />
      <Sections.Footer.Copyright />
    </Pages.Fade>
  );
};

export default HomePage;
